import { observable, computed, action, IObservableArray } from "mobx";

import { CollectionStoreImpl } from "./CollectionStore";
import { WizardStore, IWizardStore } from "./AppStore";
import { Strings } from "../Stores/StringsStore";

export class MoveDocumentWizardStore extends WizardStore implements IWizardStore {

	constructor(public collectionStore: CollectionStoreImpl) {
		super();
	}


	/**
  * Open the wizard for moving documents.
  */
	open = (): void => {
		this.wizardCaption = Strings.documentManagement.documentEdit.moveDocumentsCaption;
		this.wizardInformation = Strings.documentManagement.documentEdit.moveDocumentsText;
		this.collectionStore.moveTreeViewStoreDocuments.inMoveMode = true;
		this.isOpen = true;
	}

	/**
   * Callback for confirming the wizard operation.
   */
	@action onConfirmWizard = () => {
		this.collectionStore.moveTreeViewStoreDocuments.moveDocumentItems();
		this.collectionStore.toggleDocumentSelectionMode();
		this.isOpen = false;
	}

	/**
	* Callback fro canceling the wizard operation.
	*/
	@action onCancelWizard = () => {
		this.collectionStore.documentSelectionMode = true;
		this.isOpen = false;
		this.collectionStore.resetDocumentMove();

	}

}